import React from "react";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

const CurrentItemsLabel = ({ numItems, numItemsPerPage, currentPage }) => {
  const numItemsPerPageValue =
    numItemsPerPage === "All" ? numItems : numItemsPerPage;
  const currentItemsLabelContent = ({ from, to, numItems }) => {
    return from === to
      ? `${to} of ${numItems}`
      : `${from}-${to} of ${numItems}`;
  };

  return (
    <Box pr={4}>
      <Typography variant="body2" color="textSecondary" noWrap>
        {currentItemsLabelContent({
          from: numItems === 0 ? 0 : currentPage * numItemsPerPageValue + 1,
          to: Math.min(numItems, (currentPage + 1) * numItemsPerPageValue),
          numItems
        })}
      </Typography>
    </Box>
  );
};

export default CurrentItemsLabel;

CurrentItemsLabel.propTypes = {
  /**
   * The total number of items in the list/table
   */
  numItems: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The current number of results shown per page
   */
  numItemsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The current page of results
   */
  currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
